export default "__VITE_ASSET__DxPmqrMA__"